/* Version: 3.5.137 */
'use client';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var blogIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    focusable: "false",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("path", {
      fill: "#FFF",
      fillRule: "evenodd",
      d: "M14.052 4h5.9l-.06 9.995a4.001 4.001 0 0 1-4 3.996h-1.84v.01H3c-1.654 0-3-1.347-3-3V.03h14.052V4zm0 2v9.991h1.84a2 2 0 0 0 2-1.998L17.948 6h.001-3.898zM2 2.03V15c0 .551.449 1 1 1h9.052V2.03H2zM4 7V5h5.999v2H4zm0 4V9h5.999v2H4z"
    })]
  });
});

export { blogIcon as default };
